import { netcdfGcms } from 'netcdf-gcms';
import { fromJSON } from "../chromatogram.js";
export function fromNetCDF(netcdf) {
    return fromJSON(netcdfGcms(netcdf));
}
//# sourceMappingURL=netcdf.js.map